import React from 'react';
import sal from 'sal.js';

import Layout from '~/layouts/header-footer';

import SEO from '~/components/seo';
import Form from '~/components/form';

class TalkPage extends React.Component {
  componentDidMount() {
    sal({
      threshold: 0.1,
    });
  }

  render = () => pug`
    Layout(page={ to: '/talk', title: 'Talk to me' })
      SEO(title="Talk to me", description="Hey, don't be shy! I'm just a button away!")
      .talk
        .centered-container
          .big-body
            p(data-sal="text-animation") Whether it’s a crazy idea for a new collaboration or you just want to say hi, I'm only a button away!
          .form__container(data-sal="slide-up")
            Form(name="talk")
  `;
}

export default TalkPage;
